import { API_BASE_URL } from '../config/api';
import { getPreferredMediaRecorderMimeType } from './voiceCaptureSupport';

export async function warmUpMicrophone(existingStream?: MediaStream | null): Promise<MediaStream | null> {
  if (existingStream?.active) return existingStream;
  if (!navigator.mediaDevices?.getUserMedia) return null;

  try {
    return await navigator.mediaDevices.getUserMedia({
      audio: {
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true,
      },
    });
  } catch {
    return null;
  }
}

export async function transcribeAudioBlob(blob: Blob, language?: string): Promise<string> {
  const token = localStorage.getItem('token') || localStorage.getItem('auth_token');
  const extension = blob.type.includes('mp4') || blob.type.includes('aac') ? 'm4a' : 'webm';
  const formData = new FormData();
  formData.append('audio', blob, `recording.${extension}`);
  if (language) formData.append('language', language);

  const response = await fetch(`${API_BASE_URL}/voice/transcribe`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `Transcription failed (${response.status})`);
  }

  const data = await response.json();
  return data.text?.trim() || '';
}

export function createMediaRecorder(
  stream: MediaStream,
  onData: (chunk: Blob) => void,
): MediaRecorder {
  const mimeType = getPreferredMediaRecorderMimeType();
  const recorder = mimeType
    ? new MediaRecorder(stream, { mimeType })
    : new MediaRecorder(stream);

  recorder.addEventListener('dataavailable', (event) => {
    if (event.data.size > 0) onData(event.data);
  });

  return recorder;
}
